import React from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import type { UspBar as UspBarProps } from 'corgi-types';
import type { DisplayProps } from 'styled-system';
import { display } from 'styled-system';

import { Grid, GridItem } from 'common/components/Grid';
import type { Color } from 'common/theme/colors/types';
import { TrackingEventName, TrackingPlacement } from '../types';
import Link from './common/Link';
import Text from './common/Text';

const UrgentMessageContainer = styled.div<DisplayProps>`
  ${display};
`;

const urgentMessageWrapperStyles = {
  display: 'flex',
  alignItems: 'center',
};

const UrgentLink = styled(Link)<any>`
  ${({ textHoverColor }) =>
    textHoverColor &&
    css`
      &:active,
      &:hover,
      &:focus {
        color: ${textHoverColor};
        text-decoration-color: ${textHoverColor};
      }
    `};
`;

const UrgentMessageUspBar = ({
  text,
  textUrl: { fullUrl, target },
  textColor,
  textHoverColor,
  bgColor,
  visibleOnSmall,
  visibleOnMedium,
  visibleOnLarge,
}: UspBarProps['urgentMessage']) => (
  <UrgentMessageContainer
    data-testid="urgent-message-bar"
    display={[
      visibleOnSmall ? 'flex' : 'none',
      visibleOnMedium ? 'flex' : 'none',
      visibleOnLarge ? 'flex' : 'none',
      visibleOnLarge ? 'flex' : 'none',
    ]}
  >
    <Grid bg={bgColor as Color}>
      <GridItem {...urgentMessageWrapperStyles}>
        {fullUrl ? (
          <UrgentLink
            href={fullUrl}
            target={target}
            color={textColor}
            textHoverColor={textHoverColor}
            textDecoration="underline"
            tracking={{
              eventName: TrackingEventName.Click,
              clickedText: text,
              placement: TrackingPlacement.UrgentMessageBar,
            }}
          >
            {text}
          </UrgentLink>
        ) : (
          <Text color={textColor as Color}>{text}</Text>
        )}
      </GridItem>
    </Grid>
  </UrgentMessageContainer>
);

export default UrgentMessageUspBar;
